import { $http } from '@/plugins/common/http';
import { localeFolder } from '@/services/helpers';

export const getDomainList = (query) => {
    return $http('user/domains', {
        params: {
            ...query,
        },
    });
};

export const getDomainStatistic = () => {
    return $http('user/domains/statistics');
};

export const getDomainDetail = (id) => {
    return $http.get('/user/domains/' + id);
};

export const getEmailList = () => {
    return new Promise((resolve) => {
        const mock = [];

        resolve({
            data: {
                emails: mock,
            },
        });
    });
};

export const setAutoRenew = (id, autoRenew) => {
    return $http.patch('user/domains/' + id + '/auto-renew', {
        autoRenew: autoRenew,
    });
};

export const getDNSList = (id) => {
    return $http.get('/user/domains/' + id + '/dns');
};

export const addDNS = (id, data) => {
    return $http.put('/user/domains/' + id + '/dns', data);
};

export const deleteDNS = (id, DNSId) => {
    return $http.delete('/user/domains/' + id + '/dns/' + DNSId);
};

export const updateDNS = (id, DNSId, data) => {
    return $http.put('/user/domains/' + id + '/dns/' + DNSId, data);
};

export const updateNameservers = (id, nameservers) => {
    return $http.put('/user/domains/' + id + '/custom-dns', nameservers);
};

export const getDNSTemplateOptions = () => {
    return $http.get('/dns-template');
};

export const getMailSettings = (id) => {
    return $http.get('/user/domains/' + id + '/email-settings');
};

export const addMailSettings = (id, data) => {
    return $http.post('/user/domains/' + id + '/email-settings', data);
};

export const addMailSetting = (domainId, data) => {
    return $http.post('/user/domains/' + domainId + '/email-setting', data);
};

export const updateMailSettings = (domainId, emailSettingId, data) => {
    return $http.put(
        `/user/domains/${domainId}/email-settings/${emailSettingId}`,
        data
    );
};

export const deleteMailSettings = (domainId, emailSettingId) => {
    return $http.delete(
        `/user/domains/${domainId}/email-settings/${emailSettingId}`
    );
};

export const getPersonalNameserver = (id) => {
    return $http.get('/user/domains/' + id + '/nameserver');
};

export const addPersonalNameserver = (id, data) => {
    return $http.post('/user/domains/' + id + '/nameserver', data);
};

export const updatePersonalNameserver = (domainId, nameserverId, data) => {
    return $http.put(
        '/user/domains/' + domainId + '/nameserver/' + nameserverId,
        data
    );
};

export const deletePersonalNameserver = (domainId, nameserverId) => {
    return $http.delete(
        '/user/domains/' + domainId + '/nameserver/' + nameserverId
    );
};

export const setDNSTemplate = (id, templateId) => {
    return $http.put('/user/domains/' + id + '/template/' + templateId);
};

export const changePrivacyState = (id) => {
    return $http.put('/user/domains/' + id + '/privacy');
};

export const getLatestService = () => {
    return $http.get('/user/dashboard');
};

export const getEmailForwardingList = (domainID) => {
    return $http.get('/user/domains/' + domainID + '/email-forward');
};

export const addEmailForwarding = (domainID, data) => {
    return $http.post('/user/domains/' + domainID + '/email-forward', data);
};

export const updateEmailForwarding = (domainID, emailForwardID, data) => {
    return $http.put(
        '/user/domains/' + domainID + '/email-forward/' + emailForwardID,
        data
    );
};

export const deleteEmailForwarding = (domainID, emailForwardID) => {
    return $http.delete(
        '/user/domains/' + domainID + '/email-forward/' + emailForwardID
    );
};

export const checkDomain = (query) => {
    return $http.get('/domains/check', {
        params: {
            ...query,
        },
    });
};

export const checkDomainTransfer = (query) => {
    return $http.get('/domains/check-transfer', {
        params: {
            ...query,
        },
    });
};

export const checkoutDomainTransfer = (data) => {
    return $http.post('/checkout-one-step/domain/transfer', data);
};

export const getDomainTransferFAQs = async (locale = 'en') => {
    const data = await import('@/data/' + localeFolder(locale) + '/faq.json');
    return data?.domainTransfer;
};

export const checkReactivation = (id) => {
    return $http.get(`/user/domains/${id}/check-reactivation`);
};
